import {
    FETCH_ROOM_LIST_REQUEST,
    FETCH_ROOM_LIST_SUCCESS,
    FETCH_ROOM_LIST_FAILURE,
  } from "./FetchRoomListTypes";
  
  const initialState = {
    loading: false,
    roomDropDownList: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ROOM_LIST_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_ROOM_LIST_SUCCESS:
        return {
          loading: false,
          roomDropDownList: action.payload,
          error: "",
        };
      case FETCH_ROOM_LIST_FAILURE:
        return {
          loading: false,
          roomDropDownList: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  